var _g, _path, _g2, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApproveEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kj0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#kj-filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 22,
    fill: "#053668"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7806 4.93802L4 24V54C4 55.1046 4.89543 56 6 56H54C55.1046 56 56 55.1046 56 54V24L31.2194 4.93802C30.5005 4.38501 29.4995 4.38501 28.7806 4.93802Z",
    fill: "#1573DA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.00098,
    y: 8.00049,
    width: 42,
    height: 40,
    rx: 1,
    fill: "#FEFCFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.00098,
    y: 8.00049,
    width: 42,
    height: 40,
    rx: 1,
    fill: "url(#kj-paint0_linear)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.0699L28.32 29L36 19",
    stroke: "#00C4AC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24V54C4 55.1046 4.89543 56 6 56H54C55.1046 56 56 55.1046 56 54V24L37 42H23L4 24Z",
    fill: "#1E95F8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4 24V54C4 55.1046 4.89543 56 6 56H54C55.1046 56 56 55.1046 56 54V24L37 42H23L4 24Z",
    fill: "url(#kj-paint1_linear)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 42L53.5503 54.1949C54.3274 54.7676 53.9224 56 52.9571 56H7.04292C6.07761 56 5.67259 54.7676 6.44972 54.1949L23 42H37Z",
    fill: "#1E95F8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37 42L53.5503 54.1949C54.3274 54.7676 53.9224 56 52.9571 56H7.04292C6.07761 56 5.67259 54.7676 6.44972 54.1949L23 42H37Z",
    fill: "url(#kj-paint2_linear)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "kj-filter0_f",
    x: -16,
    y: -16,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 8.50098,
    y: 7.50049,
    width: 44,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kj-paint0_linear",
    x1: 30.9555,
    y1: 8.00049,
    x2: 19.0226,
    y2: 44.0506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kj-paint1_linear",
    x1: 27.5,
    y1: 56,
    x2: 24.45,
    y2: 30.2279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kj-paint2_linear",
    x1: 29,
    y1: 56,
    x2: 29.0001,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kj0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveEnvelope);
export default __webpack_public_path__ + "static/media/approve-envelope.09605ee2.svg";
export { ForwardRef as ReactComponent };